module.exports = __webpack_public_path__ + "img/reslove.7958ad31.png";